<div class="container ">
  <div class="row md-12">

    <div class="alert alert-info" *ngIf="inmuebles.imagen === undefined" >
      No hay resultados de la búsqueda
  </div>
    <div class="col-lg-6">
      <!-- bbb_deals -->
      <div *ngIf="inmuebles.imagen !== undefined" class="bbb_deals">

        <div class="bbb_deals_slider_container">
          <!-- bbb_deals Item -->
          <div class=" bbb_deals_item">

            <h2 for="example-date-input" style="text-align: center;">{{inmuebles.tipo}}</h2>

            <div class="p-carousel">
              <div class="carousel slide" data-ride="carousel" id="{{inmuebles._id}}">
                <div class="carousel-inner" role="listbox">
                  <div *ngFor="let avatar of inmuebles.imagen; let i = index" class="carousel-item"
                  [ngClass]="{'active': i===0}">
                  <img style="width:310px; height:310px" [src]='avatar.url' class="img-responsive image">
                </div>
                <img *ngIf="inmuebles.imagen.length===0" style="width:100%; height:100%" src="assets/images/notinmueble.png" class="img-responsive image">
                </div>

                <div>
                  <a class="carousel-control-prev" href="#{{inmuebles._id}}" role="button" data-slide="prev"><span
                      class="carousel-control-prev-icon"></span>
                    <span class="sr-only">Previous</span></a><a class="carousel-control-next" href="#{{inmuebles._id}}"
                    role="button" data-slide="next"><span class="carousel-control-next-icon"></span><span
                      class="sr-only">Next</span></a>
                </div>
              </div>
            </div>
            <div class="bbb_deals_info_line d-flex flex-row justify-content-start">
              <div class="bbb_deals_item_price_a ml-auto"
                [ngStyle]="{'background-color':inmuebles.estado == 'DISPONIBLE' ? '#007bff':'#fc4b6c'}">
                <b>{{inmuebles.estado}}</b></div>
            </div>
            <hr>
            <div class="bbb_deals_content">
              <div class="bbb_deals_info_line d-flex flex-row justify-content-start">
                <div class="bbb_deals_item_name">{{inmuebles.nombre}}</div>
                <div class="bbb_deals_item_price ml-auto">${{inmuebles.precioalquiler}}</div>
              </div>
              <div class="available">

                <div class="bbb_deals_item_category">Dirección:</div>
                <div class="available_title">{{inmuebles.direccion}}</div>
                <br>
                <div class="bbb_deals_item_category">Servicios incluidos:</div>
                <div class="available_title">{{inmuebles.servicio? inmuebles.servicio : 'no se incluye servicios'}}</div>
                <br>
                <div class="bbb_deals_item_category">Descripción:</div>
                <div class="available_title">{{inmuebles.descripcion}}</div>
                <div class="available_bar"><span style="width:17%"></span></div>
              </div>
            </div>
          </div>
        </div>
      </div> <!-- Featured -->
    </div>
    <br>
    <div class="col-lg-6 mx-auto">
      <div class="card bbb_deals">
        <div class="card-body">
          <form #formaVisita="ngForm" (ngSubmit)="crearVisita(formaVisita)" class="form p-t-20">
            <div class="row">
              <div class="col">

                <div class="form-group row">

                  <div class="col-12">
                    <h2 for="example-date-input">Solicitar visita</h2>
                    <input [ngModel]="inmuebles.nombre" name="nombre" hidden class="form-control" type="text">
                  </div>


                  <div class="col-12 m-t-10">
                    <h6 for="example-date-input">Fecha de visita</h6>
                    <input ngModel name="fecha" name="fecha" class="form-control" type="date">
                  </div>


                  <div class="col-md-12 form-group m-t-10">
                    <label for="celular">Descripción</label>
                    <div class="input-group">
                      <div class="input-group-addon"></div>
                      <textarea [(ngModel)]="descripcion" name="descripcion" type="text" required class="form-control"
                        aria-label="With textarea" rows="5" ></textarea>
                    </div>
                    <span *ngIf="formaVisita.submitted && formaVisita.controls['descripcion'].errors"
                      class="text-danger animated fadeIn m-l-10">Ingrese una descripción</span>
                  </div>
                </div>

              </div>
            </div>
            <div class="form-group text-center">
              <div class="col-xs-12">
                <button class="btn btn-block btn-lg btn-info btn-rounded"  type="submit">
                  Solicitar visita
                </button>

              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
